export default {
  "content": "<title>Analytics</title><path d=\"M344 280l88-88m-200 24l64 64M80 320l104-104\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"456\" cy=\"168\" r=\"24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"320\" cy=\"304\" r=\"24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"208\" cy=\"192\" r=\"24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"56\" cy=\"344\" r=\"24\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};